/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsSignUpConfirm204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsSignUpConfirm505Schema = z.any();

export const optionsSignUpConfirmMutationResponseSchema = z.lazy(() => optionsSignUpConfirm204Schema);
